module.exports = __webpack_public_path__ + "static/media/notcontent.daf5b17d.png";